const updateUrl = (itemId) => {
	let urlParams = "";
	if (itemId) {
		urlParams = `#${String(itemId)}`;
	}
	window.history.pushState(null, "", urlParams);
};

export default updateUrl;